/**
 * Redirection configuration: relation between the country master checkbox and its depot checkboxes
 * Requirements (current behavior):
 *   - When toggling the master checkbox:
 *     - when checked: check all related sub‑checkboxes (data-depot-country="<country>")
 *     - when unchecked: uncheck all related sub‑checkboxes
 *   - When toggling a sub‑checkbox:
 *     - When it becomes unchecked: also uncheck the master checkbox for that country
 *     - When it becomes checked: should all sub-checkboxes become selected, select master checkbox as well
 */

(function () {
    function init() {
        const form = document.querySelector('[data-form="redirection-configuration"]');
        if (!form) return;

        const countryMasters = form.querySelectorAll('input[type="checkbox"][data-country]');
        countryMasters.forEach(function (master) {
            master.addEventListener('change', function () {
                const country = master.getAttribute('data-country');
                if (!country) {
                    return;
                }
                const depots = form.querySelectorAll('input[type="checkbox"][data-depot-country="' + country + '"]');
                depots.forEach(function (depot) {
                    depot.checked = !!master.checked;
                });
            });

            // Apply initial state on load
            const country = master.getAttribute('data-country');
            if (country && master.checked) {
                const depots = form.querySelectorAll('input[type="checkbox"][data-depot-country="' + country + '"]');
                depots.forEach(function (depot) {
                    depot.checked = true;
                });
            }

            // Sub‑checkbox listeners: if unchecked, uncheck the master as well; if all become checked, check master
            if (country) {
                const subDepots = form.querySelectorAll('input[type="checkbox"][data-depot-country="' + country + '"]');
                subDepots.forEach(function (depot) {
                    depot.addEventListener('change', function () {
                        // After the change, the new checked state is already reflected
                        if (!depot.checked) {
                            master.checked = false;
                        } else {
                            // If this click checked a sub‑checkbox, and now all sub‑checkboxes are checked, check the master as well.
                            let allChecked = true;
                            subDepots.forEach(function (d) {
                                if (!d.checked) allChecked = false;
                            });
                            if (allChecked) {
                                master.checked = true;
                            }
                        }
                    });
                });

                // Initial synchronization: if all sub‑checkboxes are pre‑checked, ensure master is checked too
                if (Array.from(subDepots).filter((subdepot) => subdepot.checked === true).length) {
                    master.checked = true;
                }
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
